import HeaderLayout from "./layouts/HeaderLayout";
import { Box, Divider } from "@mui/joy";
import { Outlet } from "react-router-dom";
import CreateProfileModal from "./components/profile/CreateProfileModal";
import EditProfileModal from "./components/profile/EditProfileModal";
import { useAuthFlow } from "./utils/customHooks";

function App() {
  useAuthFlow();
  console.log("App component rendering");
  return (
    <Box
      sx={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <HeaderLayout />
      <Divider />

      <CreateProfileModal />
      <EditProfileModal />
      <Box
        sx={{
          flex: 1,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default App;
